/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   getFilters
 */

import type { TopListable } from '@zcode/bizos'
import { oisEmpty } from '@zcode/nr-utils'
import type {
  Listable,
  MaybeEmptyProperty,
  Pin,
  RawPinInventorySearch,
  State,
} from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { selectFilters } from '../../filters/selectors/index'

export const getFilters = (
  state: State,
  entity:
    | MaybeEmpty<Listable>
    | MaybeEmptyProperty
    | Pin<RawPinInventorySearch>
    | TopListable
    | null
    | undefined
) => {
  const filters = selectFilters(state)
  if (oisEmpty(entity)) {
    return filters
  }
  const shortTerm = entity.isShortTermViewV1
  return { ...filters, longTerm: !shortTerm, shortTerm }
}
